var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"gift-animation-container"},[_c('div',{staticClass:"mask",class:{ 'mask-fade-out': _vm.isAnimationComplete }}),_vm._v(" "),_c('div',{staticClass:"halo_wrapper"},[_c('div',{staticClass:"star-bg",class:{
        'gift-scale': _vm.isFirstStage
      },style:({
        background: 'url(' + _vm.haloBackgroundImage + ') no-repeat center',
        'background-size': '100% 100%'
      })}),_vm._v(" "),_c('div',{staticClass:"star-bg",class:{
        'star-bg-grow': _vm.isFirstStage,
        'star-bg-pulse': _vm.isSecondStage
      },style:({
        background: 'url(' + _vm.starBackgroundImage + ') no-repeat center',
        'background-size': '100% 100%'
      })})]),_vm._v(" "),_c('div',{staticClass:"gift-wrapper flex ai-c jc-sb",class:{
      'gift-scale': _vm.isFirstStage,
      'gift-fade-out': _vm.isThirdStage
    }},[_c('div',{staticClass:"gift-box",style:({
        background: 'url(' + _vm.box + ') no-repeat center',
        'background-size': '100% 100%'
      })}),_vm._v(" "),_c('div',{staticClass:"gift-lid",class:{ 'lid-open': _vm.isSecondStage },style:({
        background: 'url(' + _vm.lid + ') no-repeat center',
        'background-size': '100% 100%'
      })})]),_vm._v(" "),_c('div',{staticClass:"result-image",class:{
      'result-appear': _vm.isThirdStage,
      'result-pulse': _vm.isFourthStage
    },style:({
      backgroundImage: ("url(" + (_vm.result.img_path) + ")")
    })},[_c('img',{staticClass:"w-50 pos-a l0 r0 m-auto",staticStyle:{"bottom":"8%"},attrs:{"src":'/static/images/blindBoxPop/btn_' + (_vm.result.qrcode_link ? '1' : '2') + '.png',"alt":""},on:{"click":_vm.resultHandle}}),_vm._v(" "),(_vm.isTextShow)?_c('p',{staticClass:"f15 color-F pos-a l0 r0 ml25 mr25",class:{ 'ta-c': _vm.result.draw_num <= 0 },staticStyle:{"bottom":"-18%"}},[_vm._v("\n      "+_vm._s(_vm.result.draw_num > 0
          ? '十周年盲盒抽奖，每人下单可解锁' +
            _vm.result.all_num +
            '次机会。订单若退款，奖品同步收回且机会不予补发。'
          : '十周年盲盒抽奖机会已用完。')+"\n    ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5403f21d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/blindBoxPop.vue
// module id = null
// module chunks = 